import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { RefreshCw } from "lucide-react";

export default function BranchingScenario() {
  const { id } = useParams();
  const [scenario, setScenario] = useState(null);
  const [nodeId, setNodeId] = useState("start");
  const [path, setPath] = useState([]); // [{nodeId, optionId, score}]
  const [done, setDone] = useState(false);

  useEffect(() => { api.get(`/scenarios/${id}`).then(r => setScenario(r.data)); }, [id]);

  if (!scenario) return <div className="text-sm text-neutral-500">Loading…</div>;

  const node = (scenario.branches || []).find(b => b.id === nodeId);
  const totalScore = path.reduce((sum, p) => sum + p.score, 0);
  const maxScore = path.length ? path.length * 10 : 10;
  const finalPercent = Math.round((totalScore / maxScore) * 100);

  const choose = (opt) => {
    const newPath = [...path, { nodeId, optionId: opt.id, score: opt.score }];
    setPath(newPath);
    if (opt.next === "END" || !opt.next) {
      setDone(true);
      const percent = Math.round((newPath.reduce((s,p)=>s+p.score,0) / (newPath.length*10)) * 100);
      api.post("/roleplay/branch", { scenario_id: id, choices: newPath.map(p=>p.optionId), score: percent })
        .then(() => toast.success("Drill logged"));
    } else {
      setNodeId(opt.next);
    }
  };

  const restart = () => { setNodeId("start"); setPath([]); setDone(false); };

  return (
    <div className="max-w-3xl mx-auto space-y-10">
      <div>
        <Link to="/scenarios" className="label-eyebrow" data-testid="back-scenarios">← All role-plays</Link>
        <div className="mt-3 label-eyebrow text-[var(--brand-primary)]">{scenario.difficulty} · branching drill</div>
        <h1 className="font-display text-4xl md:text-5xl leading-tight mt-2">{scenario.title}</h1>
        <p className="text-neutral-500 mt-3">{scenario.description}</p>
      </div>

      {!done && node && (
        <div className="border hairline bg-white p-8">
          <div className="label-eyebrow mb-3">Prompt</div>
          <div className="font-display text-2xl leading-snug">{node.prompt}</div>

          <div className="mt-8 space-y-3">
            {(node.options||[]).map((opt) => (
              <button
                key={opt.id}
                onClick={()=>choose(opt)}
                data-testid={`branch-opt-${opt.id}`}
                className="w-full text-left border hairline px-5 py-4 hover:bg-[color:var(--brand-surface2)] transition-colors"
              >
                <span className="font-mono text-xs text-neutral-400 mr-3">{opt.id.toUpperCase()}</span>
                {opt.text}
              </button>
            ))}
          </div>
        </div>
      )}

      {done && (
        <div className="border hairline bg-white p-8" data-testid="branch-result">
          <div className="label-eyebrow">Result</div>
          <div className="font-display text-6xl mt-2">{finalPercent}%</div>
          <div className="text-sm text-neutral-500 mt-2">
            {finalPercent >= 80 ? "Excellent — that's exactly the posture we teach." :
             finalPercent >= 50 ? "Good instincts. Let's tighten a few responses and try again." :
             "Review the objection playbook and take another pass — you'll get it."}
          </div>
          <button className="btn-primary mt-8 inline-flex items-center gap-2" onClick={restart} data-testid="branch-restart">
            <RefreshCw size={14}/> Run it again
          </button>
        </div>
      )}
    </div>
  );
}
